import { render, staticRenderFns } from "./posvideoplay.vue?vue&type=template&id=12cfaa35&scoped=true&"
import script from "./posvideoplay.vue?vue&type=script&lang=js&"
export * from "./posvideoplay.vue?vue&type=script&lang=js&"
import style0 from "./posvideoplay.vue?vue&type=style&index=0&id=12cfaa35&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cfaa35",
  null
  
)

export default component.exports